import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollDefinitionService } from 'app/core/services/payroll-definition.service';
import { RefreshDeductionService } from 'app/core/services/refresh-deduction/refresh-deduction.service';

@Component({
  selector: 'dialog-delete-deduction',
  templateUrl: './dialog-delete-deduction.component.html',
  styleUrls: ['./dialog-delete-deduction.component.scss']
})
export class DialogDeleteDeductionComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteDeductionComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private payrollDefinitionService: PayrollDefinitionService,
    private refreshDeductionService: RefreshDeductionService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteDeduction() {
    this.isLoading = true;
    this.payrollDefinitionService.deleteDeduction(this.data.id).subscribe({
      next: (res) => {
        this.refreshDeductionService.emitRefresh(this.data.index);
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting category:', err);
      },
    });
  }
}
